import { Link } from "react-router-dom";
import PageLayout from "../components/site/PageLayout";
import { Button } from "../components/ui/button";

const NotFound = () => (
  <PageLayout title="404">
    <section className="relative pt-32 pb-32 overflow-hidden">
      <div className="ambient" aria-hidden />
      <div className="ambient-grid" aria-hidden />
      <div className="container-tt max-w-2xl text-center">
        <div className="font-display text-7xl md:text-9xl text-transparent bg-clip-text bg-gradient-to-b from-sky to-skyDark">404</div>
        <h1 className="font-display text-3xl md:text-4xl mt-4">This page took a wrong turn.</h1>
        <p className="mt-4 text-lg text-muted-foreground">The link may be broken, or the page might have been moved. Let's get you back on track.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Button asChild className="btn-pill btn-motion btn-sky-fill h-12 px-6 text-white shadow-sky hover:shadow-skyHover border-0"><Link to="/" data-testid="notfound-home">Go home</Link></Button>
          <Button asChild variant="outline" className="btn-pill btn-motion h-12 px-6 border-stone/15 bg-white/70 hover:bg-stone hover:border-stone hover:text-white"><Link to="/contact">Contact us</Link></Button>
        </div>
      </div>
    </section>
  </PageLayout>
);
export default NotFound;
